import { render, staticRenderFns } from "./MakeOwnerButton.vue?vue&type=template&id=039dc931&"
import script from "./MakeOwnerButton.vue?vue&type=script&lang=ts&"
export * from "./MakeOwnerButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports